import React, { useEffect, useState } from "react";

import { roundNumber } from "../../../../../../utils/NumberHelpers";
import { storageLocal as storage } from "../../../../../../utils/StorageHandler";
import NewFormRow from "../../../../../shared/forms/NewFormRow";
import NewSelect from "../../../../../shared/forms/NewSelect";
import useCalulatorStore from "../../../CalculatorPage/store";
import useOverlayStore from "../../StepOverview/store";
import useCheckoutStore from "../../store";
import useDeliveryDetailsStore from "../store";
import * as styles from "./style.module.scss";

const AntiFreeze = () => {
    const [antiFreeze, setAntiFreeze] = useDeliveryDetailsStore((state) => [
        state.antiFreeze,
        state.setAntiFreeze,
    ]);
    const [additions] = useCalulatorStore((state) => [state.additions]);
    const [overlayContent] = useOverlayStore((state) => [state.overlayContent]);
    const [detailsHasChanged] = useCheckoutStore((state) => [
        state.detailsHasChanged,
    ]);

    const [antiFreezeOptions, setAntiFreezeOptions] = useState([]);

    useEffect(() => {
        // If we have an add for anti freeze, create the additions array.
        if (additions && additions.anti_freeze_add) {
            const options = [{ value: 0, price: null }];
            for (let i = 1; i <= 10; i++) {
                options.push({
                    value: i,
                    price: roundNumber(
                        parseFloat(
                            additions.anti_freeze_add.replace(",", ".")
                        ) * i
                    ),
                });
            }
            setAntiFreezeOptions(options);
        }
    }, [additions]);

    /**
     * When the anti freeze changes.
     */
    const onChangeAntiFreeze = (event) => {
        setAntiFreeze(event.target.value);
        detailsHasChanged();
    };

    /**
     * When the user changes the frostschutz in the overlay.
     * Will be saved without pushing the save button.
     */
    useEffect(() => {
        if (overlayContent === "lieferdetails:frostschutz") {
            storage.set("hel:gtag:subject", "anti-freeze");
            storage.set(
                "hel:gtag:initial-value",
                storage.get("hel:anti-freeze")
            );
            storage.set("hel:gtag:current-value", antiFreeze);
        }
    }, [antiFreeze, overlayContent]);

    if (additions && additions.anti_freeze_add) {
        return (
            <>
                <NewFormRow>
                    <NewFormRow.Label>Kälteschutz</NewFormRow.Label>
                    <NewFormRow.Value>
                        <NewSelect
                            value={antiFreeze}
                            onChange={onChangeAntiFreeze}
                            options={antiFreezeOptions.map((option) => {
                                if (option.price === null) {
                                    return {
                                        value: option.value,
                                        text: "Ohne",
                                    };
                                }
                                return {
                                    value: option.value,
                                    text: `${option.value} Flasche${
                                        option.value > 1 ? "n" : ""
                                    } ${option.price} €`,
                                };
                            })}
                        />
                    </NewFormRow.Value>
                </NewFormRow>

                <div className={styles.antiFreezeInfo}>
                    1 Flasche reicht für etwa 1.000 Liter Heizöl.
                </div>
            </>
        );
    }
    return null;
};

export default AntiFreeze;
